import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventIcon } from "../EventIcon";
export const StatisticsIcon = (props) => {
    const isEmpty = !props.hasStatistics;
    const tooltip = !isEmpty ? props.tooltip : "";
    return (React.createElement(EventIcon, { isEmpty: isEmpty, hideOnMobile: true, tooltip: tooltip, onClick: props.handler },
        React.createElement(Icon, { i: `i-24-16 ${props.hasStatistics ? "i-o-ev-statistics" : ""}` })));
};
//# sourceMappingURL=StatisticsIcon.js.map